import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { usePostHog } from "posthog-js/react";
import { IntegrationTypeEnum, StatusStateEnum } from "~/types/enums";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert, Button, Modal } from "~/components-shared";
import authSelectors from "~/store/auth/selectors";
import authActionCreators from "~/store/auth/actions";
import profileContactInfoSchema from "~/forms/ProfileContactInfoForm/profileContactInfoSchema";
import ProfileContactInfoForm from "~/forms/ProfileContactInfoForm";
import integrationSelectors from "~/store/integrations/selectors";
import { helpers } from "~/lib/helpers";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const ProfileContactInfoUpdateModal = _ref => {
  let {
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(authSelectors.getUser);
  const status = useSelector(authSelectors.getStatus);
  const error = useSelector(authSelectors.getError);
  const slackIntegration = useSelector(integrationSelectors.getIntegrationByType(IntegrationTypeEnum.SLACK));
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const defaultValues = {
    slackUserId: user?.metadata.slackUserId,
    githubLogin: user?.metadata.githubLogin,
    jiraAccountId: user?.metadata.jiraAccountId,
    linearUserId: user?.metadata.linearUserId
  };
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    resolver: yupResolver(profileContactInfoSchema(!!slackIntegration)),
    defaultValues
  });
  const onSubmit = handleSubmit(data => {
    dispatch(authActionCreators.updateContactInfoStarted(data, _ref2 => {
      let {
        data: newUser
      } = _ref2;
      if (newUser) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("ProfileContactInfoUpdateModal.contactInfoUpdated"),
          timeout: 10000
        }));
        onClose();
      }
    }));
    posthog.capture(`Profile Contact Info – Save`, {
      ...helpers.objectDiff(defaultValues, data)
    });
  });
  const handleCancel = () => {
    dispatch(authActionCreators.actionChanged(undefined));
    onClose();
    posthog.capture(`Profile Contact Info – Cancel`);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    onClose: onClose,
    title: t("ProfileContactInfoUpdateModal.updateContactInformation"),
    fullWidth: true,
    maxWidth: "560px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(ProfileContactInfoForm, {
    control: control,
    setValue: setValue
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleCancel,
    rounded: true,
    display: "inline-block"
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    display: "inline-block",
    maxWidth: "230px",
    type: "submit",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("common.actions.save")))));
};
export default ProfileContactInfoUpdateModal;